// import { ViewSupport43Component } from "../../../components/SupportSystem/ViewReports/ViewSupport43Component";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { OperationReport43Component } from "../../../components/SupportSystem/OperationReportForm/OperationReport43Component";
export function ViewSupport43Container() {
    const titleName = "แบบรายงานผลการพิจารณาอนุมัติการให้เงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน (แบบ ชอ. 4-3)"; //ใส่ชื่อtitle ตรงนี้
    return (
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <OperationReport43Component />
            <Footer />
        </div>
    );
}
